module.exports = __webpack_public_path__ + "static/media/ordering-showcase.3c52bc80.webm";